"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useAnchor(href) {
    const [anchor, setAnchor] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (href) {
            const a = document.createElement('a');
            a.target = '_blank';
            a.rel = 'noreferrer noopener';
            a.href = href;
            setAnchor(a);
        }
        ;
        () => {
            if (anchor) {
                anchor.remove();
            }
        };
    }, [href]);
    return (0, react_1.useCallback)(() => {
        anchor && anchor.click();
    }, [anchor]);
}
exports.default = useAnchor;
